import { Component, ViewEncapsulation, OnInit, OnDestroy, ViewChildren, AfterViewInit, QueryList, ElementRef, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';
import { GtmService } from 'ngx-gtm';
import { AuthService } from '../services/auth.service';
import { OidcHelperService } from '../services/oidc-helper.service';

const BASE_URL = 'https://televisallega.com';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private gtm: GtmService,
    private auth: AuthService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ){
    this.gtm.push({event: 'TelevisaLlega'});
    this.auth.loginByApp().subscribe(resp => {
      //console.log('Resp login:', resp)
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateCanonicalUrl(event.urlAfterRedirects);
      });
  }

  private updateCanonicalUrl(url: string): void {
    const canonicalUrl = BASE_URL + url.split('?')[0];
    let link: HTMLLinkElement = this.document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
  }
}
